import React, {
  useContext,
  useEffect,
} from "react";
import styles from "../Wyszukiwarka.module.css";
import { AppContext } from "context/AppContext";
import DecodeToken from "pages/Login/DecodeToken";
import { useZamowienia } from 'hooks/useZamowienia';


  export default function Opiekun({opiekun, setOpiekun }) {


const contextApp = useContext(AppContext);

        const { globalSearch } = useZamowienia();

        useEffect(() => {
      globalSearch();
    
  }, [opiekun]);

if (DecodeToken(sessionStorage.getItem("token")).zamowienia_wszystkie == 1) {



  return (
    <div className={styles.colData}>
      <label className={styles.labelData}> Opiekun </label>
      <select
        className={styles.inputData}
        style={{width:"270px"}}
        value={opiekun}
        onChange={(event) => {
          setOpiekun( event.target.value);
        }}
      >
        <option key={1} value={"0"}> 
           wybierz...
          </option>
        {contextApp.users?.map((option) => (
          <option key={option.id} value={option.id}>
            {option.Imie} {option.Nazwisko}
          </option>
        ))}
      </select>

    </div>
  );
} else {
  return (
    <div className={styles.colData}>
      <label className={styles.labelData}> Opiekun </label>
      <select
        className={styles.inputData}
        style={{width:"270px"}}
        value={opiekun}
        onChange={(event) => {
          setOpiekun( event.target.value);
        }}
      >
        <option key={1} value={"0"}> 
           ---
          </option>

      </select>

    </div>
  );

}
}